import React from "react";
import styles from "./Categories.module.css";
import image1 from "../../Images/noimage.jpeg";
import image2 from "../../Images/2.png";
import image3 from "../../Images/3.png";
import image4 from "../../Images/4.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Spinner from 'react-bootstrap/Spinner';

const Categories = ({ onCardClick }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const navigate = useNavigate();
  const {Categories, loading} = useSelector((state) => state.CategoriesSlice);

  const onSubmit = (card) => {
    console.log("card", card);
    navigate("/services");
    localStorage.setItem("card", JSON.stringify(card));
    console.log("card", card);
  };
  return (
    <div>
   {loading ? <div style={{display:"flex", justifyContent:"center"}}>

<Spinner animation="border" role="status" style={{width:"100px", height:"100px"}}/>
</div>:
<div>
{Categories && Categories?.length > 0 ? 
  <div className={styles.cardContainer}>
      {Categories?.map((card) => (
        <div
          key={card.cats_num}
          className={styles.card}
          onClick={() => {
            onSubmit(card);
          }}
        >
          <img src={(card?.cats_IMG && card?.cats_IMG?.trim() !="" ) ? `https://reservation.ladycaresa.com/public/uploads${card.cats_IMG}` : image1} alt={card.label} className={styles.cardImage} />
          <div className={styles.cardLabel}>
            <span>
              {
                currentLanguage === "ar"
                  ? card.cats_nam.trim() // Arabic branch name
                  : card.cats_enm.trim() || card.cats_nam.trim() // English branch name (fallback to Arabic if empty)
              }
            </span>
          </div>
        </div>
      ))}
    </div>
    : <div style={{
      display:"flex",
      justifyContent:"center",
      alignItems:"center",
      fontSize:"28px",
      fontWeight:"900",
      margin:"70px"
    }}>{t('ThereAreNoCategoriesAvailableInThisBranch')} </div>  
  }
  </div>
}
    </div>
  
  );
};

export default Categories;
